import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { difference, keys, isEmpty, pluck } from "ramda";
import { documentId, getDocs, query, where } from "firebase/firestore";
import { profiles, projects } from "@config/firestore";
import { ADD_USER_PROFILES, ADD_RANDOM_PROJECTS, ADD_POPULAR_PROJECTS, SEARCH_PROJECTS_REQUEST, SEARCH_PROJECTS_SUCCESS, SET_POPULAR_PROJECTS_OFFSET, SET_RANDOM_PROJECTS_LOADING } from "./types";
import { convertProjectSnapToProject, firestoreProjectToIProject } from "@comp/projects/utils";
var databaseID = process.env.REACT_APP_DATABASE === "DEV" ? "dev" : "prod";
var searchURL = "https://web-ide-search-api.csound.com/search/".concat(databaseID);
// const searchURL = `http://localhost:4000/search/${databaseID}`;
export var searchProjects = function searchProjects(query_, offset) {
    return /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(dispatch) {
            var searchRequest, projects, searchResult, userIDs, projectProfiles, profilesQuery;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({
                                type: SEARCH_PROJECTS_REQUEST,
                                query: query_,
                                offset: offset
                            });
                            if (!isEmpty(query_)) {
                                _context.next = 3;
                                break;
                            }
                            return _context.abrupt("return");
                        case 3:
                            _context.next = 5;
                            return fetch("".concat(searchURL, "/query/projects/").concat(query_, "/8/").concat(offset, "/name/desc"));
                        case 5:
                            searchRequest = _context.sent;
                            _context.next = 8;
                            return searchRequest.json();
                        case 8:
                            projects = _context.sent;
                            projects.data = projects.data.slice(0, 8);
                            searchResult = projects.data.map(firestoreProjectToIProject);
                            userIDs = pluck("userUid", searchResult);
                            if (isEmpty(userIDs)) {
                                _context.next = 19;
                                break;
                            }
                            projectProfiles = {};
                            _context.next = 16;
                            return getDocs(query(profiles, where(documentId(), "in", userIDs)));
                        case 16:
                            profilesQuery = _context.sent;
                            profilesQuery.forEach(function (snapshot) {
                                var _projectProfiles$snap;
                                projectProfiles[snapshot.id] = snapshot.data();
                                if ((_projectProfiles$snap = projectProfiles[snapshot.id]) !== null && _projectProfiles$snap !== void 0 && _projectProfiles$snap.userJoinDate) {
                                    projectProfiles[snapshot.id].userJoinDate = projectProfiles[snapshot.id].userJoinDate.toMillis();
                                }
                            });
                            dispatch({
                                type: ADD_USER_PROFILES,
                                payload: projectProfiles
                            });
                        case 19:
                            dispatch({
                                type: SEARCH_PROJECTS_SUCCESS,
                                result: searchResult,
                                totalRecords: projects.totalRecords
                            });
                        case 20:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var fetchPopularProjects = function fetchPopularProjects() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    return /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(dispatch, getState) {
            var nextOffset, state, starsRequest, starredProjects, starsIDs, publicProjectsSnapshots, popularProjects, userIDs, missingProfiles, projectProfiles, profilesQuery;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1)
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            nextOffset = Math.max(0, offset) + pageSize;
                            dispatch({
                                type: SET_POPULAR_PROJECTS_OFFSET,
                                newOffset: nextOffset
                            });
                            state = getState().HomeReducer;
                            _context3.next = 5;
                            return fetch("".concat(searchURL, "/list/stars/").concat(pageSize, "/").concat(offset, "/count/desc"));
                        case 5:
                            starsRequest = _context3.sent;
                            _context3.next = 8;
                            return starsRequest.json();
                        case 8:
                            starredProjects = _context3.sent;
                            starsIDs = starredProjects.data.map(function (item) {
                                return item.id;
                            });
                            if (isEmpty(starsIDs)) {
                                _context3.next = 27;
                                break;
                            }
                            _context3.next = 13;
                            return getDocs(query(query(projects, where("public", "==", true)), where(documentId(), "in", starsIDs)));
                        case 13:
                            publicProjectsSnapshots = _context3.sent;
                            _context3.next = 16;
                            return Promise.all(publicProjectsSnapshots.docs.map(/*#__PURE__*/ function () {
                                var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(snap) {
                                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                        while (1)
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    _context2.next = 2;
                                                    return convertProjectSnapToProject(snap);
                                                case 2:
                                                    return _context2.abrupt("return", _context2.sent);
                                                case 3:
                                                case "end":
                                                    return _context2.stop();
                                            }
                                    }, _callee2);
                                }));
                                return function (_x4) {
                                    return _ref3.apply(this, arguments);
                                };
                            }()));
                        case 16:
                            popularProjects = _context3.sent;
                            userIDs = pluck("userUid", popularProjects);
                            missingProfiles = difference(userIDs, keys(state.profiles));
                            if (isEmpty(missingProfiles)) {
                                _context3.next = 26;
                                break;
                            }
                            projectProfiles = {};
                            _context3.next = 23;
                            return getDocs(query(profiles, where(documentId(), "in", missingProfiles)));
                        case 23:
                            profilesQuery = _context3.sent;
                            profilesQuery.forEach(function (snapshot) {
                                var _projectProfiles$snap2;
                                projectProfiles[snapshot.id] = snapshot.data();
                                if ((_projectProfiles$snap2 = projectProfiles[snapshot.id]) !== null && _projectProfiles$snap2 !== void 0 && _projectProfiles$snap2.userJoinDate) {
                                    projectProfiles[snapshot.id].userJoinDate = projectProfiles[snapshot.id].userJoinDate.toMillis();
                                }
                            });
                            dispatch({
                                type: ADD_USER_PROFILES,
                                payload: projectProfiles
                            });
                        case 26:
                            dispatch({
                                type: ADD_POPULAR_PROJECTS,
                                payload: popularProjects,
                                totalRecords: starredProjects.totalRecords
                            });
                        case 27:
                        case "end":
                            return _context3.stop();
                    }
            }, _callee3);
        }));
        return function (_x2, _x3) {
            return _ref2.apply(this, arguments);
        };
    }();
};
export var fetchRandomProjects = function fetchRandomProjects() {
    return /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(dispatch, getState) {
            var state, randomProjectsRequest, randomProjects, randomProjectsIDs, randomProjectsSnapshots, _randomProjects, userIDs, missingProfiles, projectProfiles, profilesQuery;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1)
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch({
                                type: SET_RANDOM_PROJECTS_LOADING,
                                isLoading: true
                            });
                            state = getState().HomeReducer;
                            _context5.next = 4;
                            return fetch("".concat(searchURL, "/random/projects/8"));
                        case 4:
                            randomProjectsRequest = _context5.sent;
                            _context5.next = 7;
                            return randomProjectsRequest.json();
                        case 7:
                            randomProjects = _context5.sent;
                            randomProjectsIDs = randomProjects.data.map(function (item) {
                                return item.id;
                            });
                            if (isEmpty(randomProjectsIDs)) {
                                _context5.next = 26;
                                break;
                            }
                            _context5.next = 12;
                            return getDocs(query(query(projects, where("public", "==", true)), where(documentId(), "in", randomProjectsIDs)));
                        case 12:
                            randomProjectsSnapshots = _context5.sent;
                            _context5.next = 15;
                            return Promise.all(randomProjectsSnapshots.docs.map(/*#__PURE__*/ function () {
                                var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(snap) {
                                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                                        while (1)
                                            switch (_context4.prev = _context4.next) {
                                                case 0:
                                                    _context4.next = 2;
                                                    return convertProjectSnapToProject(snap);
                                                case 2:
                                                    return _context4.abrupt("return", _context4.sent);
                                                case 3:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                    }, _callee4);
                                }));
                                return function (_x7) {
                                    return _ref5.apply(this, arguments);
                                };
                            }()));
                        case 15:
                            _randomProjects = _context5.sent;
                            userIDs = pluck("userUid", _randomProjects);
                            missingProfiles = difference(userIDs, keys(state.profiles));
                            if (isEmpty(missingProfiles)) {
                                _context5.next = 25;
                                break;
                            }
                            projectProfiles = {};
                            _context5.next = 22;
                            return getDocs(query(profiles, where(documentId(), "in", missingProfiles)));
                        case 22:
                            profilesQuery = _context5.sent;
                            profilesQuery.forEach(function (snapshot) {
                                var _projectProfiles$snap3;
                                projectProfiles[snapshot.id] = snapshot.data();
                                if ((_projectProfiles$snap3 = projectProfiles[snapshot.id]) !== null && _projectProfiles$snap3 !== void 0 && _projectProfiles$snap3.userJoinDate) {
                                    projectProfiles[snapshot.id].userJoinDate = projectProfiles[snapshot.id].userJoinDate.toMillis();
                                }
                            });
                            dispatch({
                                type: ADD_USER_PROFILES,
                                payload: projectProfiles
                            });
                        case 25:
                            dispatch({
                                type: ADD_RANDOM_PROJECTS,
                                payload: _randomProjects
                            });
                        case 26:
                            dispatch({
                                type: SET_RANDOM_PROJECTS_LOADING,
                                isLoading: false
                            });
                        case 27:
                        case "end":
                            return _context5.stop();
                    }
            }, _callee5);
        }));
        return function (_x5, _x6) {
            return _ref4.apply(this, arguments);
        };
    }();
};
